import { render } from "./Dataprotection.vue?vue&type=template&id=c891a052"
import script from "./Dataprotection.vue?vue&type=script&lang=js"
export * from "./Dataprotection.vue?vue&type=script&lang=js"

import "./Dataprotection.vue?vue&type=style&index=0&id=c891a052&lang=css"

import exportComponent from "C:\\PROJEKTE\\SLP_DE\\APP\\sjp_de\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__